/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import rules from '../../constants/businessRules/businessRules';
import Tooltip from '../Tooltip';
import * as Styled from './styles';

export default class Input extends PureComponent {
    state = {
        ref: React.createRef(),
    };

    componentDidUpdate = (prevProps, prevState) => {
        const { isFocused } = prevProps;
        const { ref } = prevState;

        if (isFocused && ref && ref.current) {
            ref.current.focus();
        }
    }

    render() {
        const {
            border,
            styling,
            type,
            width,
            initialValue,
            placeholder,
            label,
            labelWidth,
            labelFontWeight,
            labelIcon,
            labelIconTooltip,
            labelIconTooltipWidth,
            labelIconTooltipPadding,
            icon,
            onChange,
            onBlur,
            disabled,
            min,
            max,
            minLength,
            maxLength,
            marginBottom,
            rotate,
            customIcon,
            defaultValue,
            value,
            id,
        } = this.props;
        const {
            ref,
        } = this.state;
        switch (type) {
            case 'number-small':
                return (
                    <div
                        data-test-id={`${id}-input`}
                        style={{
                            height: 28,
                            padding: 5,
                            maxWidth: width || 85,
                            width,
                            boxSizing: 'border-box',
                            border,
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            marginBottom,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginRight: 5,
                                transform: rotate ? 'rotate(90deg)' : 0,
                                maxWidth: 17,
                            }}
                        >
                            <i className="material-icons" style={{ fontSize: 17, color: '#727273' }}>
                                {icon}
                            </i>
                        </div>
                        <label htmlFor={id}>
                            <input
                                type="number"
                                min={min || 0}
                                max={max || rules.MAXIMUM_ALLOWABLE_GUTTER}
                                id={id}
                                placeholder={placeholder}
                                style={{
                                    border: 'none',
                                    color: '#424242',
                                    outline: 'none',
                                    fontWeight: 600,
                                    maxWidth: 19,
                                    minWidth: 0,
                                    textAlign: 'right',
                                    ...styling,
                                }}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={initialValue}
                                ref={ref}
                            />
                        </label>
                        <div
                            style={{
                                fontSize: 12,
                                fontWeight: 600,
                                display: 'flex',
                                alignItems: 'center',
                                color: '#424242',
                            }}
                        >
                            px
                        </div>
                    </div>
                );
            case 'text':
                return (
                    <div style={{ width: width || '100%', marginBottom, pointerEvents: disabled ? 'none' : null }}>
                        <div style={{ display: 'flex' }}>
                            {!!label && (
                                <h3
                                    style={{
                                        height: 24,
                                        display: 'inline-block',
                                        width: labelWidth,
                                        color: '#424242',
                                        fontSize: 10,
                                        fontWeight: labelFontWeight,
                                        letterSpacing: 1,
                                        lineHeight: '18px',
                                    }}
                                    data-test-id={`${id}-label`}
                                >
                                    {label}
                                </h3>
                            )}
                            {!!labelIcon && (
                                <Tooltip
                                    id="label-icon-tooltip"
                                    text={labelIconTooltip}
                                    width={labelIconTooltipWidth}
                                    padding={labelIconTooltipPadding}
                                    place="top"
                                >
                                    <i className="material-icons" style={{ fontSize: 13, color: '#727273', margin: '3px 2px' }}>
                                        {labelIcon}
                                    </i>
                                </Tooltip>
                            )}
                        </div>
                        <div
                            style={{
                                flexGrow: 1,
                                boxSizing: 'border-box',
                                border,
                                display: 'flex',
                                alignItems: 'center',
                                height: 28,
                                padding: 4,
                                marginBottom: 0,
                                ...styling,
                            }}
                        >
                            {customIcon ? (
                                <img src={customIcon} alt="" style={{ marginRight: 5, width: 13 }} />
                            ) : (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginRight: 5,
                                    }}
                                >
                                    <i className="material-icons" style={{ fontSize: 17, color: '#727273' }}>
                                        {icon}
                                    </i>
                                </div>
                            )}
                            <Styled.InputDiv
                                type={type}
                                placeholder={placeholder}
                                ref={ref}
                                id={id}
                                minLength={minLength}
                                maxLength={maxLength}
                                data-test-id={id ? `${id}-input` : `${label}-input`}
                                customStyle={styling}
                                defaultValue={defaultValue}
                                value={value}
                                onChange={onChange}
                                onBlur={onBlur}
                            />
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }
}

Input.propTypes = {
    border: PropTypes.string,
    type: PropTypes.string.isRequired,
    marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    width: PropTypes.number,
    initialValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    customIcon: PropTypes.string,
    styling: PropTypes.object,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    labelWidth: PropTypes.number,
    labelFontWeight: PropTypes.number,
    labelIcon: PropTypes.string,
    labelIconTooltip: PropTypes.string,
    labelIconTooltipWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    labelIconTooltipPadding: PropTypes.string,
    icon: PropTypes.string,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rotate: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.string.isRequired,
    defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isFocused: PropTypes.bool,
};

Input.defaultProps = {
    border: '1px solid #CCCCCC',
    defaultValue: undefined,
    marginBottom: 10,
    width: 180,
    labelWidth: 180,
    labelFontWeight: 700,
    labelIconTooltipWidth: '180px',
    labelIconTooltipPadding: '8px 21px',
    minLength: 0,
    maxLength: 1200,
    isFocused: false,
};
